
import { Component, Input } from '@angular/core';
import { FieldOkItemComponent } from '@softline/dynamic';

@Component({
  selector: 'soft-field-ok-abcanalyse-list-view',
  imports: [],
  templateUrl: './abcanalyse.list-view.html',
  styleUrls: ['./abcanalyse.list-view.css'],
})
export class AbcAnalyseListView implements FieldOkItemComponent<any> {
  @Input() item: any;
}
